import { EMPTY_OBJECT } from '../../../constants/common'
import { isEmptyString } from '../../../utils/common'
import Button from '../../Button'
import { getEmptyStateActions } from '../../PageEmptyState'

import {
  REQUEST_PROFILE_TAB_DOC_FLOWS_ACTION_DISCONNECT,
  REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY,
  REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME,
  REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_FILTER_KEY,
} from './RequestProfileTabDocFlows.constants'

import LinkIcon from '../../../icons/link-1.svg'

export function hasRequestProfileTabDocFlowsItems(docFlows) {
  return docFlows?.items?.length > 0
}

export function isRequestProfileTabDocFlowsSearchActive(searchQuery) {
  return !isEmptyString(searchQuery)
}

export function getRequestProfileTabDocFlowsActions(t) {
  return [
    {
      label: t('RequestProfile.DocFlowsDisconnectActionOptionKey'),
      value: REQUEST_PROFILE_TAB_DOC_FLOWS_ACTION_DISCONNECT,
    },
  ]
}

export function getRequestProfileTabDocFlowsEmptyStateActions({
  canCreateDocFlow,
  isLoading,
  shouldShowActions,
  t,
  onClickConnect,
  onClickCreate,
}) {
  return [
    ...getEmptyStateActions({
      actionName: REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.emptyCreate,
      isLoading,
      qaName: REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.emptyCreate,
      shouldShowActions: shouldShowActions && canCreateDocFlow,
      text: t(REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY.create),
      onClick: onClickCreate,
    }),
    ...getEmptyStateActions({
      Component: Button.Outlined,
      Icon: LinkIcon,
      actionName: REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.emptyConnect,
      isLoading,
      qaName: REQUEST_PROFILE_TAB_DOC_FLOWS_QA_NAME.emptyConnect,
      shouldShowActions,
      text: t(REQUEST_PROFILE_TAB_DOC_FLOWS_BUTTON_TEXT_KEY.connect),
      onClick: onClickConnect,
    }),
  ]
}

export function getRequestProfileTabDocFlowsSearchFilters(searchQuery) {
  return isRequestProfileTabDocFlowsSearchActive(searchQuery)
    ? { [REQUEST_PROFILE_TAB_DOC_FLOWS_SEARCH_FILTER_KEY]: searchQuery }
    : EMPTY_OBJECT
}
